import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

import { UnAuthorizedVersion as LanguagePopover } from 'shared/components/LanguagePopover'
import { useNavigate, useSearchParams } from 'react-router-dom'
import ContainedButton from 'shared/components/Buttons/ContainedButton'

export default function OrderReflinkComplete() {
   const { t } = useTranslation('UNAUTHORIZED')
   const [searchParams] = useSearchParams()
   const navigate = useNavigate()

   useEffect(() => {
      if (searchParams.get('uuid')) {
         setTimeout(() => {
            navigate(`/client-cart-reflink?uuid=${searchParams.get('uuid')}`)
         }, 5000)
      }
   }, [searchParams])

   return (
      <>
         <Box sx={{ display: 'flex', justifyContent: 'flex-end', px: { md: 10, xs: 3 }, py: 1 }}>
            <LanguagePopover />
         </Box>
         <Box
            sx={{
               display: 'flex',
               flexDirection: 'column',
               gap: '8px',
               justifyContent: 'center',
               mt: '20%',
               textAlign: 'center',
            }}
         >
            <Typography variant="h2" color="grayText">
               {t('orderReflinkComplete.title')}
            </Typography>
            {searchParams.get('uuid') && (
               <Typography variant="h3" color="grayText">
                  {t('orderReflinkComplete.refreshText')}
               </Typography>
            )}
            {searchParams.get('uuid') && (
               <ContainedButton
                  sx={{ alignSelf: 'center' }}
                  onClick={() => navigate(`/client-cart-reflink?uuid=${searchParams.get('uuid')}`)}
               >
                  {t('orderReflinkComplete.back')}
               </ContainedButton>
            )}
         </Box>
      </>
   )
}
